function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import isEmpty from 'ramda/src/isEmpty';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { validateNumbers } from 'invision-core/src/utilities/input.helper';
import LocaleKeys from '../../../locales/keys';
import { createDiscretionaryGridColumnDefs, createRegularGridColumnDefs, discountTypes } from './decision.override.discount.dialog.helper';
var DecisionOverrideDiscountController = /*#__PURE__*/function () {
  function DecisionOverrideDiscountController(uiGridConstants, uiGridFilterBySearch) {
    _classCallCheck(this, DecisionOverrideDiscountController);
    Object.assign(this, {
      areOnlyGlobalDiscountsSelectedOnRegularTab: null,
      clientSearch: this.clientSearch.bind(this),
      clearSelectedDiscretionaryDiscounts: this.clearSelectedDiscretionaryDiscounts.bind(this),
      clearSelectedRegularDiscounts: this.clearSelectedRegularDiscounts.bind(this),
      CoreLocaleKeys: CoreLocaleKeys,
      countryName: '',
      defaultDiscountsForSelectedBri: [],
      discountTypes: discountTypes,
      discretionaryDiscountTableData: [],
      discretionaryGrid: {},
      filterData: this.filterData.bind(this),
      filterText: '',
      getSavings: this.getSavings.bind(this),
      getMaxRegularDiscountSelectionText: this.getMaxRegularDiscountSelectionText.bind(this),
      hasZeroDiscount: false,
      initializeDiscretionaryTableDataSelections: this.initializeDiscretionaryTableDataSelections.bind(this),
      initializeRegularTableDataSelections: this.initializeRegularTableDataSelections.bind(this),
      isFilteredResultEmpty: false,
      isReasonCodeSelectionDisabled: this.isReasonCodeSelectionDisabled.bind(this),
      LocaleKeys: LocaleKeys,
      lookForDefault: this.lookForDefault.bind(this),
      onDiscretionaryGridRegisterApi: this.onDiscretionaryGridRegisterApi.bind(this),
      onDiscountOverrideTabSelected: this.onDiscountOverrideTabSelected.bind(this),
      regularDiscountTableData: [],
      regularGrid: {},
      selectedDiscretionaryDiscounts: {},
      selectedRegularDiscounts: {},
      selectedDiscretionaryReasonCode: null,
      showDiscretionaryTabContent: this.showDiscretionaryTabContent.bind(this),
      showRegularTabContent: this.showRegularTabContent.bind(this),
      totalDiscounts: 0,
      uiGridConstants: uiGridConstants,
      uiGridFilterBySearch: uiGridFilterBySearch,
      updateSelectedDiscretionaryDiscounts: this.updateSelectedDiscretionaryDiscounts.bind(this),
      updateOverriddenDiscountAmount: this.updateOverriddenDiscountAmount.bind(this),
      updateSelectedRegularDiscounts: this.updateSelectedRegularDiscounts.bind(this),
      validateNumbers: validateNumbers
    });
  }
  return _createClass(DecisionOverrideDiscountController, [{
    key: "$onInit",
    value: function $onInit() {
      this.discretionaryGrid = {
        enableSorting: true,
        appScopeProvider: this,
        onRegisterApi: this.onDiscretionaryGridRegisterApi,
        columnDefs: createDiscretionaryGridColumnDefs(),
        data: this.discretionaryTableData,
        enableHorizontalScrollbar: this.uiGridConstants.scrollbars.NEVER,
        enableFullRowSelection: true,
        enableRowSelection: true,
        enableRowHeaderSelection: false,
        rowTemplate: require('./rowTemplates/row.template.html')
      };
      this.regularGrid = {
        enableSorting: true,
        appScopeProvider: this,
        columnDefs: createRegularGridColumnDefs(),
        data: this.regularTableData,
        enableHorizontalScrollbar: this.uiGridConstants.scrollbars.NEVER,
        enableFullRowSelection: true,
        enableRowSelection: true,
        enableRowHeaderSelection: false,
        rowTemplate: require('./rowTemplates/row.template.html')
      };
      this.lookForDefault();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this = this;
      var currentDiscretionaryTableData = pathOr(undefined, ['discretionaryTableData', 'currentValue'], changesObj);
      if (this.discretionaryGrid && currentDiscretionaryTableData) {
        this.discretionaryGrid.data = this.initializeDiscretionaryTableDataSelections(currentDiscretionaryTableData);
      }
      var currentRegularTableData = pathOr(undefined, ['regularTableData', 'currentValue'], changesObj);
      if (this.regularGrid && currentRegularTableData) {
        this.regularGrid.data = this.initializeRegularTableDataSelections(currentRegularTableData);
      }
      this.defaultDiscountsForSelectedBri = pathOr([], ['option', 'DefaultSelectedDiscounts'], this.configuration).filter(function (selectedDiscounts) {
        return selectedDiscounts.BillerRuleConfigurationId === _this.selectedBri.billerRuleConfigurationId;
      });
    }
  }, {
    key: "initializeDiscretionaryTableDataSelections",
    value: function initializeDiscretionaryTableDataSelections(discretionaryTableData) {
      var _this2 = this;
      var areAnyDiscretionaryDiscountsSelected = false;
      var updatedTableData = [];
      discretionaryTableData.forEach(function (tableData) {
        var matchingSelectedDiscretionaryDiscountInfo = _this2.selectedDiscountsInfo.find(function (discountInfo) {
          return "".concat(discountInfo.DiscountId) === tableData.discountId && discountInfo.DiscretionaryDiscountReason;
        });
        tableData.isSelected = !!matchingSelectedDiscretionaryDiscountInfo;
        if (tableData.isSelected) {
          areAnyDiscretionaryDiscountsSelected = true;
          _this2.selectedDiscretionaryReasonCode = matchingSelectedDiscretionaryDiscountInfo.DiscretionaryDiscountReason;
          _this2.updateSelectedDiscretionaryDiscounts(tableData);
        }
        updatedTableData.push(tableData);
      });
      return updatedTableData;
    }
  }, {
    key: "initializeRegularTableDataSelections",
    value: function initializeRegularTableDataSelections(regularTableData) {
      var _this3 = this;
      var areAnyRegularDiscountsSelected = false;
      var updatedTableData = [];
      regularTableData.forEach(function (tableData) {
        var matchingSelectedRegularDiscountInfo = _this3.selectedDiscountsInfo.find(function (discountInfo) {
          return "".concat(discountInfo.DiscountId) === tableData.discountId && (discountInfo.DiscretionaryDiscountReason === undefined || discountInfo.DiscretionaryDiscountReason === null);
        });
        tableData.isSelected = !!matchingSelectedRegularDiscountInfo;
        if (tableData.isSelected) {
          areAnyRegularDiscountsSelected = true;
          _this3.updateSelectedRegularDiscounts(tableData);
        }
        updatedTableData.push(tableData);
      });
      return updatedTableData;
    }
  }, {
    key: "onDiscretionaryGridRegisterApi",
    value: function onDiscretionaryGridRegisterApi(gridApi) {
      this.discretionaryGridApi = gridApi;
      gridApi.grid.api.grid.registerRowsProcessor(this.clientSearch);
    }
  }, {
    key: "clientSearch",
    value: function clientSearch(rows, columnDefs) {
      var filteredResult = this.uiGridFilterBySearch(rows, columnDefs, this.filterText);
      this.isFilteredResultEmpty = !filteredResult.some(function (item) {
        return item.visible;
      });
      return filteredResult;
    }
  }, {
    key: "filterData",
    value: function filterData(searchTerm) {
      this.filterText = searchTerm;
      this.discretionaryGridApi.grid.refresh(true);
    }
  }, {
    key: "getSavings",
    value: function getSavings(rowEntity) {
      return rowEntity.discountAmountType === this.discountTypes.percentageOff.value ? +(this.selectedBri.chargeAmount * rowEntity.amount / 100) : +rowEntity.amount;
    }
  }, {
    key: "validateDiscounts",
    value: function validateDiscounts() {
      if (this.totalDiscounts > this.selectedBri.chargeAmount) {
        this.warningMessage = i18n.translate(this.LocaleKeys.CART.DISCOUNT_MODAL.DISCOUNT_WARNING);
      } else {
        this.warningMessage = null;
      }
      var allDiscounts = [].concat(_toConsumableArray(Object.values(this.selectedRegularDiscounts)), _toConsumableArray(Object.values(this.selectedDiscretionaryDiscounts)));
      this.hasZeroDiscount = !!allDiscounts.find(function (discount) {
        return discount.savings === 0;
      });
      if (this.hasZeroDiscount) {
        this.warningMessage = i18n.translate(this.LocaleKeys.CART.DISCOUNT_MODAL.AMOUNT_ZERO_WARNING);
      }
    }
  }, {
    key: "updateTotalDiscounts",
    value: function updateTotalDiscounts() {
      var totalRegularDiscounts = (Object.values(this.selectedRegularDiscounts) || []).reduce(function (accumulator, object) {
        return object.isSelected ? accumulator + object.savings : accumulator;
      }, 0);
      var totalDiscretionaryDiscounts = (Object.values(this.selectedDiscretionaryDiscounts) || []).reduce(function (accumulator, object) {
        return object.isSelected ? accumulator + object.savings : accumulator;
      }, 0);
      this.totalDiscounts = totalRegularDiscounts + totalDiscretionaryDiscounts;
      this.validateDiscounts();
    }
  }, {
    key: "updateSelectedDiscretionaryDiscounts",
    value: function updateSelectedDiscretionaryDiscounts(rowEntity) {
      var _this4 = this;
      if (rowEntity.isSelected) {
        this.selectedDiscretionaryDiscounts[rowEntity.discountId] = rowEntity;
      } else {
        delete this.selectedDiscretionaryDiscounts[rowEntity.discountId];
        this.discretionaryGrid.data = this.discretionaryGrid.data.map(function (item) {
          return item.discountId === rowEntity.discountId ? _objectSpread(_objectSpread({}, item), {}, {
            amount: item.defaultAmount,
            savings: _this4.getSavings(_objectSpread(_objectSpread({}, item), {}, {
              amount: item.defaultAmount
            })),
            isOverridden: false
          }) : item;
        });
      }
      this.updateTotalDiscounts();
    }
  }, {
    key: "updateSelectedRegularDiscounts",
    value: function updateSelectedRegularDiscounts(rowEntity) {
      var _this5 = this;
      if (rowEntity.isSelected) {
        this.selectedRegularDiscounts[rowEntity.discountId] = rowEntity;
      } else {
        delete this.selectedRegularDiscounts[rowEntity.discountId];
        this.regularGrid.data = this.regularGrid.data.map(function (item) {
          return item.discountId === rowEntity.discountId ? _objectSpread(_objectSpread({}, item), {}, {
            amount: item.defaultAmount,
            savings: _this5.getSavings(_objectSpread(_objectSpread({}, item), {}, {
              amount: item.defaultAmount
            })),
            isOverridden: false
          }) : item;
        });
      }
      this.updateTotalDiscounts();
      this.areOnlyGlobalDiscountsSelectedOnRegularTab = Object.values(this.selectedRegularDiscounts).every(function (selectedDiscount) {
        return selectedDiscount.isGlobalDiscount;
      });
    }
  }, {
    key: "updateOverriddenDiscountAmount",
    value: function updateOverriddenDiscountAmount(rowEntity) {
      var savings = this.getSavings(rowEntity);
      if (this.showRegularTabContent()) {
        this.selectedRegularDiscounts[rowEntity.discountId] = _objectSpread(_objectSpread({}, rowEntity), {}, {
          isOverridden: true,
          savings: savings
        });
      } else {
        this.selectedDiscretionaryDiscounts[rowEntity.discountId] = _objectSpread(_objectSpread({}, rowEntity), {}, {
          isOverridden: true,
          savings: savings
        });
      }
      this.updateTotalDiscounts();
    }
  }, {
    key: "getMaxRegularDiscountSelectionText",
    value: function getMaxRegularDiscountSelectionText() {
      var selectionLimit = this.defaultDiscountsForSelectedBri.length || 1;
      return i18n.translate(this.defaultDiscountsForSelectedBri.length > 1 ? this.LocaleKeys.CART.DISCOUNT_MODAL.MAXIMUM_REGULAR_DISCOUNT_SELECTIONS : this.LocaleKeys.CART.DISCOUNT_MODAL.MAXIMUM_REGULAR_DISCOUNT_SELECTION, {
        max: selectionLimit
      });
    }
  }, {
    key: "clearSelectedDiscretionaryDiscounts",
    value: function clearSelectedDiscretionaryDiscounts() {
      this.discretionaryGrid.data.forEach(function (item) {
        item.isSelected = false;
        item.amount = item.defaultAmount;
      });
      this.selectedDiscretionaryDiscounts = {};
      this.selectedDiscretionaryReasonCode = null;
      this.updateTotalDiscounts();
    }
  }, {
    key: "clearSelectedRegularDiscounts",
    value: function clearSelectedRegularDiscounts() {
      var _this6 = this;
      Object.keys(this.selectedRegularDiscounts).forEach(function (discountId) {
        if (!_this6.selectedRegularDiscounts[discountId].isGlobalDiscount) {
          delete _this6.selectedRegularDiscounts[discountId];
        }
      });
      this.regularGrid.data.forEach(function (item) {
        if (!item.isGlobalDiscount) {
          item.isSelected = false;
          item.amount = item.defaultAmount;
        }
      });
      this.areOnlyGlobalDiscountsSelectedOnRegularTab = this.areRegularDiscountsSelected();
      this.updateTotalDiscounts();
    }
  }, {
    key: "onDiscountOverrideTabSelected",
    value: function onDiscountOverrideTabSelected(selectedTab) {
      this.configuration.tabs.forEach(function (tab) {
        tab.active = tab.name === selectedTab.name;
      });
      this.configuration.selectedTab = selectedTab;
    }
  }, {
    key: "areDiscretionaryDiscountsSelected",
    value: function areDiscretionaryDiscountsSelected() {
      return !isEmpty(this.selectedDiscretionaryDiscounts);
    }
  }, {
    key: "areRegularDiscountsSelected",
    value: function areRegularDiscountsSelected() {
      return !isEmpty(this.selectedRegularDiscounts);
    }
  }, {
    key: "showDiscretionaryTabContent",
    value: function showDiscretionaryTabContent() {
      return this.configuration.selectedTab.name === i18n.translate(this.LocaleKeys.CART.DISCOUNT_MODAL.DISCRETIONARY) && this.discretionaryTableData.length;
    }
  }, {
    key: "showRegularTabContent",
    value: function showRegularTabContent() {
      return this.configuration.selectedTab.name === i18n.translate(this.LocaleKeys.CART.DISCOUNT_MODAL.REGULAR) && this.regularTableData.length;
    }
  }, {
    key: "isReasonCodeSelectionDisabled",
    value: function isReasonCodeSelectionDisabled() {
      return this.selectedDiscretionaryReasonCode && pathOr(null, ['option', 'OfferingDecisionOptionInstances', 0, 'SubscriberProductId'], this.configuration) || pathOr(null, ['option', 'OfferingDecisionOptionInstances', 0, 'TransferSubscriberProductId'], this.configuration);
    }
  }, {
    key: "onCloseHandler",
    value: function onCloseHandler() {
      this.configuration.onCloseModal();
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit() {
      var _this7 = this;
      this.discountForm.$setSubmitted();
      this.validateDiscounts();
      if (!this.warningMessage) {
        if (this.discountForm.$valid) {
          this.warningMessage = null;
          var selectedDiscretionaryDiscountsWithReasonCode = this.getSelectedDiscretionaryDiscountsWithReasonCode(this.selectedDiscretionaryDiscounts, this.selectedDiscretionaryReasonCode);
          var allSelectedDiscounts = Object.assign({}, selectedDiscretionaryDiscountsWithReasonCode, this.selectedRegularDiscounts);
          var selectedDiscountsInfo = Object.values(allSelectedDiscounts).map(function (discount) {
            var discountInfo = _objectSpread(_objectSpread({
              BillerRuleConfigurationId: _this7.selectedBri.billerRuleConfigurationId,
              DiscountId: discount.discountId,
              DiscountAmount: discount.savings
            }, discount.isOverridden ? {
              DiscountOverrideAmount: discount.discountAmountType === _this7.discountTypes.percentageOff.value ? discount.amount / 100 : discount.amount
            } : {}), {}, {
              SubscriberProductDiscountId: (_this7.selectedDiscountsInfo.find(function (discountInfo) {
                return discountInfo.BillerRuleConfigurationId === _this7.selectedBri.billerRuleConfigurationId && discountInfo.DiscountId === convertStringToNumber(discount.discountId);
              }) || {}).SubscriberProductDiscountId
            });
            if (discount.discretionaryDiscountReason) {
              discountInfo.DiscretionaryDiscountReason = discount.discretionaryDiscountReason;
            }
            return discountInfo;
          });
          this.configuration.onSubmit(this.configuration.decision.Id, this.configuration.option.Id, this.selectedBri.billerRuleConfigurationId, selectedDiscountsInfo);
        } else {
          this.onDiscountOverrideTabSelected({
            name: i18n.translate(this.LocaleKeys.CART.DISCOUNT_MODAL.DISCRETIONARY)
          });
        }
      }
    }
  }, {
    key: "getSelectedDiscretionaryDiscountsWithReasonCode",
    value: function getSelectedDiscretionaryDiscountsWithReasonCode(selectedDiscretionaryDiscounts, reasonCode) {
      var selectedDiscretionaryDiscountsWithReasonCode = {};
      Object.keys(selectedDiscretionaryDiscounts).forEach(function (discountId) {
        selectedDiscretionaryDiscountsWithReasonCode["".concat(discountId)] = Object.assign({}, selectedDiscretionaryDiscounts["".concat(discountId)], {
          discretionaryDiscountReason: reasonCode
        });
      });
      return selectedDiscretionaryDiscountsWithReasonCode;
    }
  }, {
    key: "handleRemoveDiscount",
    value: function handleRemoveDiscount() {
      this.configuration.onRemoveDiscount(this.configuration.decision.Id, this.configuration.option.Id);
    }
  }, {
    key: "lookForDefault",
    value: function lookForDefault() {
      var bri = pathOr({}, ['PricingPlanBillerRuleInstances', 'RecurringBillerRuleInstances', 0], this.configuration.selectedOption);
      var discount = pathOr([], ['BillerRuleInstanceDiscounts'], bri).find(function (dis) {
        return !!dis.IsDefault;
      });
      var defaultDiscount = discount ? discount.DiscountId : null;
      if (defaultDiscount) {
        this.selectedDiscount = "".concat(discount.DiscountId, "_").concat(bri.Id);
      }
    }
  }]);
}();
export default {
  bindings: {
    configuration: '<',
    discretionaryTableData: '<',
    hasMultipleDiscountAccess: '<',
    isLoading: '<',
    regularTableData: '<',
    selectedBri: '<',
    selectedDiscountsInfo: '<',
    warningMessage: '<'
  },
  template: require('./decision.override.discount.dialog.template.html'),
  controller: DecisionOverrideDiscountController
};